// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadedCasesDIV {
    padding: 74px 182px;
}

.innerContent {
    border-radius: 8px;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #E7E7E9;
    padding: 60px;
    justify-content: center;
}

.innerContent > * {
    align-self: center;
}

.addDataIcon {
    color: #9CA3AF;
}

.noCasesDIV {
    margin: 16px 0px 26px 0px;
}

.noCasesHeader {
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 5px;
    color: var(--integration-text-color);
}

.noCasesInfo {
    font-size: 14px;
    color: var(--integration-light-text-color);
    text-align: center;
}

.addCaseButton {
    font-size: 15px;
    color: var(--integration-text-color);
}

.integrationWhiteButton {
    margin: 0px 28px;
}

.useCaseDataRow {
    font-size: 15px;
    color: var(--integration-light-text-color);
}

.loadedCasesHeader {
    font-size: 32px;
    font-weight: bold;
    color: var(--integration-text-color);
}

.loadedCasesHeaderRow, .loadedCasesSearchRow {
    margin-bottom: 35px;
}

.useCaseStateBox {
    font-size: 12px;
    border-radius: 12px;
    padding: 5px 8px;
}

    .useCaseStateBox > .pi {
        margin-right: 8px;
    }

.useCaseRunningBox {
    background-color: #F4F4F5;
    border: 1px solid var(--integration-border-color);
}

    .useCaseRunningBox > .pi {
        animation-duration: 1.5s;
    }

    .useCaseSuccessBox {
        border: 1px solid var(--integration-border-color);
    }

.useCaseFailureBox {
    background-color: #EF4444;
    color: #FFFFFF;
}
`, "",{"version":3,"sources":["webpack://./src/app/integration/smartintegration/smart.integration.control.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,yBAAyB;IACzB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;IAEI;QACI,iBAAiB;IACrB;;AAEJ;IACI,yBAAyB;IACzB,iDAAiD;AACrD;;IAEI;QACI,wBAAwB;IAC5B;;IAEA;QACI,iDAAiD;IACrD;;AAEJ;IACI,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".loadedCasesDIV {\n    padding: 74px 182px;\n}\n\n.innerContent {\n    border-radius: 8px;\n    box-shadow: 0px 3px 6px #00000029;\n    border: 1px solid #E7E7E9;\n    padding: 60px;\n    justify-content: center;\n}\n\n.innerContent > * {\n    align-self: center;\n}\n\n.addDataIcon {\n    color: #9CA3AF;\n}\n\n.noCasesDIV {\n    margin: 16px 0px 26px 0px;\n}\n\n.noCasesHeader {\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n    margin-bottom: 5px;\n    color: var(--integration-text-color);\n}\n\n.noCasesInfo {\n    font-size: 14px;\n    color: var(--integration-light-text-color);\n    text-align: center;\n}\n\n.addCaseButton {\n    font-size: 15px;\n    color: var(--integration-text-color);\n}\n\n.integrationWhiteButton {\n    margin: 0px 28px;\n}\n\n.useCaseDataRow {\n    font-size: 15px;\n    color: var(--integration-light-text-color);\n}\n\n.loadedCasesHeader {\n    font-size: 32px;\n    font-weight: bold;\n    color: var(--integration-text-color);\n}\n\n.loadedCasesHeaderRow, .loadedCasesSearchRow {\n    margin-bottom: 35px;\n}\n\n.useCaseStateBox {\n    font-size: 12px;\n    border-radius: 12px;\n    padding: 5px 8px;\n}\n\n    .useCaseStateBox > .pi {\n        margin-right: 8px;\n    }\n\n.useCaseRunningBox {\n    background-color: #F4F4F5;\n    border: 1px solid var(--integration-border-color);\n}\n\n    .useCaseRunningBox > .pi {\n        animation-duration: 1.5s;\n    }\n\n    .useCaseSuccessBox {\n        border: 1px solid var(--integration-border-color);\n    }\n\n.useCaseFailureBox {\n    background-color: #EF4444;\n    color: #FFFFFF;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
